module.exports = __webpack_public_path__ + "static/media/reflect_mobile.e5e623fe.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/reflect_mobile.png
// module id = 563
// module chunks = 0